export interface PageActivity {
  isActive(): boolean
  subscribe(listener: () => void): () => void
}

let documentPageActivity: PageActivity | undefined

export function getDocumentPageActivity(): PageActivity {
  if (documentPageActivity) return documentPageActivity

  const listeners = new Set<() => void>()
  const notify = () => {
    for (const listener of listeners) listener()
  }
  documentPageActivity = {
    isActive: () => typeof document === 'undefined' || document.visibilityState !== 'hidden',
    subscribe: listener => {
      if (listeners.size === 0 && typeof document !== 'undefined') {
        document.addEventListener('visibilitychange', notify)
        window.addEventListener('pageshow', notify)
      }
      listeners.add(listener)
      return () => {
        listeners.delete(listener)
        if (listeners.size === 0 && typeof document !== 'undefined') {
          document.removeEventListener('visibilitychange', notify)
          window.removeEventListener('pageshow', notify)
        }
      }
    },
  }
  return documentPageActivity
}
